module.exports = __webpack_public_path__ + "img/access_wallet_animated_icon.7ab9de77.svg";